export default "__VITE_ASSET__CEfoV7JO__"